import React, {Component} from "react";

class Information extends Component {
    render() {
        return (
            <div>
                <p className="profile--information--name">Clement Loeuillet</p>
                <p className="profile--information--job">Fullstack developer</p>
                <p className="profile--information--email">laybraid.fr</p>
            </div>
        );
    }
}

export default Information;